import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseErrorState from '@/components/BaseErrorState';

const NotFoundError = () => {
  const { t } = useTranslation();

  return (
    <BaseErrorState
      title={t('coverage.sleepio.not_found_error_state.title')}
      subtitle={t('coverage.sleepio.not_found_error_state.subtitle')}
      supportEmail={t('coverage.sleepio.not_found_error_state.support.email')}
      supportText={t('coverage.sleepio.not_found_error_state.support.text')}
    />
  );
};

export default NotFoundError;
